/* eslint-disable @typescript-eslint/no-use-before-define */

import { takeLatest, call, put, select } from 'redux-saga/effects';

// Components

// Services
import { scheduleApi } from 'services/apiDigitalTicket/schedule';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';
import * as ScheduleActions from './actions';

// Types
import { ScheduleTypes } from './types';

function* list({
  payload,
}: ReturnType<typeof ScheduleActions.listScheduleRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Carregando dados...' }));

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(scheduleApi.list, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        ScheduleActions.listScheduleSuccess({
          scheduleList: response.data,
        }),
      );
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedule - listSchedule - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ScheduleActions.listScheduleFailure());
    yield put(DialogsActions.setClose());
  }
}

function* createByList({
  payload,
}: ReturnType<typeof ScheduleActions.createScheduleByListRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Criando Feriado...' }));

    const response = yield call(scheduleApi.createByList, {
      data: payload,
    });

    if (response.status === 200) {
      yield put(ScheduleActions.createScheduleByListSuccess());
      yield put(DialogsActions.setClose());

      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Feriado criado com sucesso',
        }),
      );
      yield put(DialogsActions.setClose());
      yield put(ScheduleActions.listScheduleRequest({ _limit: 9999 }));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedule - createScheduleByList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ScheduleActions.createScheduleByListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* updateByList({
  payload,
}: ReturnType<typeof ScheduleActions.updateScheduleByListRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Editando Feriado' }));

    const response = yield call(scheduleApi.updateByList, {
      data: payload,
    });

    if (response.status === 200) {
      yield put(ScheduleActions.updateScheduleByListSuccess());
      yield put(DialogsActions.setClose());
      yield put(
        SnackbarsActions.setOpen({
          open: true,
          type: 'success',
          message: 'Feriado editado com sucesso',
        }),
      );
      yield put(DialogsActions.setClose());
      yield put(ScheduleActions.listScheduleRequest({ _limit: 9999 }));
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedule - updateScheduleByList - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ScheduleActions.updateScheduleByListFailure());
    yield put(DialogsActions.setClose());
  }
}

function* remove({
  payload,
}: ReturnType<typeof ScheduleActions.deleteScheduleRequest>): any {
  try {
    yield put(DialogsActions.setOpenLoading({ title: 'Excluindo Feriado' }));
    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );
    const response = yield call(scheduleApi.delete, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(ScheduleActions.deleteScheduleSuccess());
      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('schedule - deleteSchedule - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(ScheduleActions.deleteScheduleFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-profile import/prefer-default-export
export const scheduleSagas = [
  takeLatest(ScheduleTypes.LIST_SCHEDULE_REQUEST, list),
  takeLatest(ScheduleTypes.CREATE_SCHEDULE_REQUEST, createByList),
  takeLatest(ScheduleTypes.UPDATE_SCHEDULE_REQUEST, updateByList),
  takeLatest(ScheduleTypes.DELETE_SCHEDULE_REQUEST, remove),
];
